// extracted by mini-css-extract-plugin
export default {"unassignButtonWrpapper":"UnassignEmployeeDragArea_unassignButtonWrpapper__QNikt"};